export default "__VITE_ASSET__CdwmvxeQ__"